import { SubscriptionTier } from './api-types';

export enum SubscriptionFeature {
  RESULT_TAILORING = 'RESULT_TAILORING',
  OPERATIONAL_DATA_INTEGRATION = 'OPERATIONAL_DATA_INTEGRATION',
  OPERATIONAL_DATA_INSIGHTS = 'OPERATIONAL_DATA_INSIGHTS',
  PRODUCT_ATTRIBUTES = 'PRODUCT_ATTRIBUTES',
  FINANCIAL_STATEMENTS_INPUT = 'FINANCIAL_STATEMENTS_INPUT',
}

const starterTierFeatures: SubscriptionFeature[] = [];

const proTierFeatures: SubscriptionFeature[] = [
  SubscriptionFeature.RESULT_TAILORING,
  SubscriptionFeature.OPERATIONAL_DATA_INTEGRATION,
  SubscriptionFeature.OPERATIONAL_DATA_INSIGHTS,
];

const enterpriseTierFeatures: SubscriptionFeature[] = [
  ...proTierFeatures,
  SubscriptionFeature.PRODUCT_ATTRIBUTES,
  SubscriptionFeature.FINANCIAL_STATEMENTS_INPUT,
];

export const subscriptionFeaturesByTier: Record<SubscriptionTier, SubscriptionFeature[]> = {
  starter: starterTierFeatures,
  pro: proTierFeatures,
  enterprise: enterpriseTierFeatures,
};
